"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCursorProvider = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledCursorProvider = styled_components_1.default.div `
    position: relative;
    width: 100%;
    height: 100%;
    min-width: min-content; // 690.53px;

    display: flex;
    align-items: center;

    & > div {
        margin: 0 auto;
    }
`;
//# sourceMappingURL=CursorProvider.styles.js.map